/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Servis_Last_UpdatedInputs */

const tr_servis_last_updated = /** @type {(inputs: Servis_Last_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`11 Ekim 2026`)
};

const en_servis_last_updated = /** @type {(inputs: Servis_Last_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`11 October 2026`)
};

const de_servis_last_updated = /** @type {(inputs: Servis_Last_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`11. Oktober 2026`)
};

const ru_servis_last_updated = /** @type {(inputs: Servis_Last_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`11 октября 2026 г.`)
};

/**
* | output |
* | --- |
* | "11 October 2026" |
*
* @param {Servis_Last_UpdatedInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const servis_last_updated = /** @type {((inputs?: Servis_Last_UpdatedInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Servis_Last_UpdatedInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_servis_last_updated(inputs)
	if (locale === "de") return de_servis_last_updated(inputs)
	if (locale === "ru") return ru_servis_last_updated(inputs)
	return tr_servis_last_updated(inputs)
});